import words from "lodash.words";

export function searchTable(search, fullData, config) {
  if (search === "" || search === null) {
    return [...fullData];
  } else {
    let temp = [...fullData];
    temp = temp.filter((item) => {
      let results = words(search.toLowerCase()).map((word) => {
        let test = false;
        config.searchFields.forEach((field) => {
          if (item[[field]] && item[[field]].toLowerCase().includes(word)) {
            test = true;
          }
        });
        return test;
      });
      return results.every((value) => value) ? true : false;
    });
    return [...temp];
  }
}
